import { PlatformLocation } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CoreHelperService } from 'src/app/services/core/core-helper.service';

@Component({
  selector: 'app-user-agreement',
  templateUrl: './user-agreement.component.html',
  styleUrls: ['./user-agreement.component.scss']
})
export class UserAgreementComponent implements OnInit {
  @Input() agreementData;
  constructor(
    private activeModal: NgbActiveModal, 
    private location: PlatformLocation, 
    public coreHelperService: CoreHelperService) {
    // location.onPopState(() => this.close());
  }
  ngOnInit(): void {
    this.coreHelperService.movableModel()
  }
  AgreeTerms() {
    this.activeModal.close('Agreed')
  }
  close() {
    this.activeModal.close()
  }
}
